import { render } from "./NcrmBoardModuleTiles.vue?vue&type=template&id=d142570c&scoped=true"
import script from "./NcrmBoardModuleTiles.vue?vue&type=script&lang=js"
export * from "./NcrmBoardModuleTiles.vue?vue&type=script&lang=js"

import "./NcrmBoardModuleTiles.vue?vue&type=style&index=0&id=d142570c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d142570c"]])

export default __exports__